import { NotificationSettings } from '@progress/kendo-angular-notification';

export const defaultSuccessNotificationOptions: NotificationSettings = {
  content: 'Action completed successfully',
  cssClass: 'button-notification',
  animation: { type: 'fade', duration: 400 },
  position: { horizontal: 'center', vertical: 'top' },
  type: { style: 'success', icon: true },
  hideAfter: 5000
};

export const defaultErrorNotificationOptions: NotificationSettings = {
  content: 'Error',
  cssClass: 'button-notification',
  animation: { type: 'fade', duration: 400 },
  position: { horizontal: 'center', vertical: 'top' },
  type: { style: 'error', icon: true },
  hideAfter: 5000
};

export function getDefaultSuccessNotificationOptions(content: string): NotificationSettings {
  return { ...defaultSuccessNotificationOptions, content };
}

// error messages
export const enrollmentErrorMsg =
  'Enrollment Failed. Please recheck your details and try again or contact administrator.';

// success messages
export const enrollmentSuccessMsg = 'Enrollment successful.';
export const accessRenewedMsg = 'Access renewed successfully';

// platforms-management
export const platformCreatedMsg = 'Platform created successfully.';
export const platformUpdatedMsg = 'Platform updated successfully.';
export const platformDeletedMsg = 'Platform deleted successfully.';

// connection-management
export const connectionUpdatedMsg = 'Connection updated successfully.';

// admin
export const changesSavedMsg = 'Changes saved successfully.';
export const userCreatedMsg = 'User created successfully.';

// client-management
export const clientCreatedMsg = 'Client created successfully.';
export const clientUpdatedMsg = 'Client updated successfully.';
export const clientDeletedMsg = 'Client deleted successfully.';

// mapping-management
export const mapperCreatedMsg = 'Mapper created successfully.';
export const mapperUpdatedMsg = 'Mapper updated successfully.';
export const mapperDeletedMsg = 'Mapper deleted successfully.';
export const copyMapperCreatedMsg = 'Mapper copied successfully.';
export const fileMapperCreatedMsg = 'Mapper saved successfully.';

// jobs
export const scheduleUpdatedMsg = 'Schedule updated successfully.';
export const scheduleDeletedMsg = 'Schedule deleted successfully.';
export const jobCreatedMsg = 'Request submitted successfully.';

// recent-job-logs
export const jobRegenerated = 'Request submitted successfully.';
